import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import Footer from '../../Component/Footer/Footer';
import AnnouncementBar from '../../Component/InshurLp/AnnouncementBar';
import Hero from '../../Component/InshurLp/Hero';
import FeatureShowcase from '../../Component/InshurLp/FeatureShowcase';
import RoadsideTolls from '../../Component/InshurLp/RoadsideTolls';
import WebsiteGuestSplit from '../../Component/InshurLp/WebsiteGuestSplit';
import MarketingReady from '../../Component/InshurLp/MarketingReady';
import AttractAudiences from '../../Component/InshurLp/AttractAudiences';
import BusinessSizes from '../../Component/InshurLp/BusinessSizes';
import ApiIntegration from '../../Component/InshurLp/ApiIntegration';
import CtaSection from '../../Component/InshurLp/CtaSection';
import '../../Component/InshurLp/InshurLp.css';

// Rentid x INSHUR partnership page, ported from the v0 /inshurlp page.
// Intentionally header-less, like /turo-alternative; the body is the ported
// partnership narrative, closed by the site Footer.
const InshurLp = () => {
  const { hash } = useLocation();

  // Client-side routing doesn't scroll on its own: honor any #anchor that
  // resolves to an element, otherwise start at the top.
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [hash]);

  return (
    <>
      <Helmet>
        <title>Rentid &amp; INSHUR — Rental Platform with Insurance Built In</title>
        <meta
          name="description"
          content="Rentid and INSHUR have partnered to give US rental businesses one platform for bookings, embedded commercial auto insurance, renter verification, fleet management, payments, and agreements."
        />
        <meta
          name="keywords"
          content="INSHUR, Rentid, embedded rental insurance, commercial auto insurance, rental platform, booking engine, fleet management, renter verification"
        />
        <meta
          property="og:title"
          content="Rentid &amp; INSHUR — Rental Platform with Insurance Built In"
        />
        <meta
          property="og:description"
          content="Access everything you need to manage your rental business with greater control — bookings, insurance, verification, fleet management, payments, and agreements in one place."
        />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://www.rentid.io/inshurlp" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <div className="inshur-lp">
        <AnnouncementBar />
        <Hero />

        <div className="ilp-stack">
          <FeatureShowcase />
          <RoadsideTolls />
          <div className="ilp-split-wrap">
            <WebsiteGuestSplit />
          </div>
          <MarketingReady />
          <AttractAudiences />
          <BusinessSizes />
          <ApiIntegration />
          <CtaSection />
        </div>
      </div>

      <Footer />
    </>
  );
};

export default InshurLp;
